
const NBSP_N = '\u202F';//Narrow non-breaking space


export function formatFallbackInterval(fallbackInterval: number | null | undefined): string {
    if (!fallbackInterval) return '';

    const timeMillis = fallbackInterval;
    const totalSeconds = Math.round(Math.abs(timeMillis / 1000));

    const hours = Math.floor(totalSeconds / 3600);
    const hoursText = `${hours.toString()}h`;

    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const minutesPadding = (hoursText && minutes < 10 ? '0' : '');
    const minutesText = minutesPadding + minutes.toString() + 'm';

    return [hoursText, minutesText].filter((it) => it).join(NBSP_N);
}
